<template>
  <div class="toggle">
    <button class="toggle-button" v-b-toggle.collapse-1>
      <img src="@/assets/images/toggle-arrow.svg" alt />
    </button>
    <b-collapse id="collapse-1">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </b-collapse>
  </div>
</template>
<script>
import CardBlock from "./cards-block";
import DescriptionBlock from "./description-block";
import LikeBlock from "./like-block";
export default {
  components: {
    CardBlock,
    DescriptionBlock,
    LikeBlock
  },
  props: {
    cards: Array,
    description: Object,
    like: Object
  }
};
</script>